import styles from "./Style.module.css";
import { Close } from "@material-ui/icons";
import { Dialog, Slide, ButtonBase } from "@material-ui/core";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const IdCardPreviewDialog = ({ isOpen, handleClose, data, handleDownload }) => {
  return (
    <Dialog
      keepMounted
      TransitionComponent={Transition}
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
    >
      <div className={styles.previewWrapper}>
        
        {/* Header */}
        <div className={styles.previewHeader}>
          <h2>Preview</h2>

          <div className={styles.headerRight}>
            <ButtonBase
              className={styles.downloadBtn}
              onClick={handleDownload}
            >
              DOWNLOAD
            </ButtonBase>

            <Close
              className={styles.closeIcon}
              onClick={handleClose}
            />
          </div>
        </div>

        <div className={styles.previewBody}>
          
          <div className={styles.card}>
            <img src={data?.front_image} alt="Front" />
          </div>

          <div className={styles.card}>
            <img src={data?.back_image} alt="Back" />
          </div>

        </div>
      </div>
    </Dialog>
  );
};

export default IdCardPreviewDialog;